<template>
    <div>
        <navbar></navbar>
        <div class="container">
            <p class="__portpnew">Equalyz.ai — Reclaiming Africa’s Voice in the Age of Generative AI</p>
            <p class="__portp2new">Data Science Nigeria partnered with Findworka to build a platform that turns hyper-local audio, text and images into Small Language Models and enterprise AI agents that truly understand African context.</p>
            <p class="__meetdname"><span class="__namp">Client Name:</span> Data Science Nigeria (DSN)</p>
            <p class="__meetdname"><span class="__namp">Product:</span> Equalyz.ai</p>
            <p class="__meetdname"><span class="__namp">Scope:</span> Data-collection engine, augmentation tools, SLM training pipeline, AI-agent frontend, analytics dashboard.</p>
            <p class="__meetdname"><i>A forward-thinking AI non-profit wanted to unlock the value buried in Lagos State spreadsheets. Together we built a tool that now guides evidence-based decisions across government and civil society.</i></p>
            
            <p class="__headin">The Challenge</p>
            <p class="__meetdname"><span class="__namp">More than an AI Tool — a Paradigm Shift</span></p>
            <p class="__meetdname">Build a platform able to collect, process and refine Africa’s spoken, written and visual data, turning it into context-aware intelligence while preserving cultural, linguistic and contextual integrity.</p>
            <p class="__meetdname">Key needs:</p>
            <ul class="__portp2new">
                <li>Diverse, multilingual datasets</li>
                <li>Scalable SLM framework</li>
                <li>Enterprise AI-agent layer</li>
                <li>Bias control & transparency</li>
            </ul>

            <p class="__headin">The Solution</p>
            <ul class="__portp2new">
                <li><b class="__namp">Hyperlocal Crowdsourcing Engine –</b> network of contributors capturing market scenes in Ibadan, chats in Onitsha, festivals in Kano…</li>
                <li><b class="__namp">Human-Enabled Data Augmentation – </b> automation plus human oversight for richness and relevance.</li>
                <li><b class="__namp">Dynamic Visualizations – </b>Clean, customizable charts and graphs that make trend tracking a breeze.</li>
                <li><b class="__namp">Small Language Model Framework – </b>lightweight, task-specific models tuned to African expressions, dialects and code-switching.</li>
                <li><b class="__namp">Enterprise AI-Agent Frontend – </b>sleek UI to deploy and customise agents for education, health and civic tech.</li>
                <li><b class="__namp">Real-Time Analytics Dashboard – </b>track dataset contributions, model performance, demographic spread, bias-detection alerts.</li>
            </ul>
            <img src="../assets/img/equalyz.png" class="__climgr"/>

            <p class="__headin">Key Features</p>
            <div class="row">
                <div class="col-xl-4 col-lg-4 col-md-4">
                    <div class="__cards">
                        <img src="../assets/img/ftlanguage.png" class="__futimg"/>
                        <p class="__meetdname"><span class="__namp">Hyperlocal Data Capture</span></p>
                        <p class="__meetdname">30+ communities, 20+ languages</p>
                    </div>
                </div>
                <div class="col-xl-4 col-lg-4 col-md-4">
                    <div class="__cards">
                        <img src="../assets/img/ftpresentation.png" class="__futimg"/>
                        <p class="__meetdname"><span class="__namp">SLM Training Pipeline</span></p>
                        <p class="__meetdname">Lightweight, context-rich models</p>
                    </div>
                </div>
                <div class="col-xl-4 col-lg-4 col-md-4">
                    <div class="__cards">
                        <img src="../assets/img/ftdashboard.png" class="__futimg"/>
                        <p class="__meetdname"><span class="__namp">AI-Agent Dashboard</span></p>
                        <p class="__meetdname">Deploy, monitor & customise agents</p>
                    </div>
                </div>
            </div>

            <p class="__headin">Results / Impact Tiles</p>
            <div class="row">
                <div class="col-xl-4 col-lg-4 col-md-4">
                    <div class="__card1">
                        <p class="__meetdname"><span class="__namp">Datasets Processed</span></p>
                        <p class="__meetdname">15,000 +</p>
                    </div>
                </div>
                <div class="col-xl-4 col-lg-4 col-md-4">
                    <div class="__card1">
                        <p class="__meetdname"><span class="__namp">Languages Represented</span></p>
                        <p class="__meetdname">20 + (Pidgin, Hausa, Yoruba…)</p>
                    </div>
                </div>
                <div class="col-xl-4 col-lg-4 col-md-4">
                    <div class="__card1">
                        <p class="__meetdname"><span class="__namp">Enterprise AI Agents</span></p>
                        <p class="__meetdname">9 live across sectors</p>
                    </div>
                </div>
            </div><br>
            <p class="__meetdname">Equalyz.ai isn’t just an AI platform — it’s Africa in digital form. Findworka engineered the technology that fuels it.</p>
            <p class="__meetdname">When Africa needs AI that listens, understands and learns from us, you don’t go global first; you build locally, intentionally and with purpose. That’s what we did with Equalyz.</p>

            

            <div class="text-center">
                <p class="__hvsip">Have an idea to ship? Let’s build it—fast.</p>
                <p class="__meetdname">Tell us about your product vision and get a scoped build plan within 48 hours.</p>
                <router-link to="/build" class="btn __viewsite">Get Started Here </router-link>
            </div>
            <div class="__whitespace"></div>
        </div>
    </div>
</template>


<script>
import navbar from '../components/navbar';

export default {
    components: { navbar },
    data(){
        return{}
    },
}
</script>

<style scoped>
@import '../assets/css/portfolio';
</style>


// WEBPACK FOOTER //
// src/components/equalyz.vue